import DxDataGrid, {
  DxColumn,
  DxLoadPanel
} from "devextreme-vue/data-grid";
import {
  DxAccordion,
  DxTagBox,
  DxCheckBox
} from 'devextreme-vue';
import {
  DxBox,
  DxItem
} from 'devextreme-vue/box';
import {
  DxButton
} from "devextreme-vue/button";
import {
  DxSpeedDialAction,
  DxSelectBox
} from 'devextreme-vue';

import {
  masterService
} from '../../services/master.service';
import {
  shiftPlanService
} from '../../services/shift-plan.service';
import {
  contactService
} from '../../services/contact.service';
import {
  shiftResultService
} from '../../services/shift-result.service';
import {
  workerService
} from '../../services/worker.service';

import ShiftInfo from './shift-info.vue';
import moment from 'moment'
import notify from 'devextreme/ui/notify'

export default {
  data() {
    return {
      shiftDataSource: [],
      bizContactsDataSource: [],
      canSubmitWorkerTimeSheetDate: null,
      hasDesiredShiftData: false,
      hasBizcontactData: false,
      currentMD: moment().format('(M月D日)'),
      defaultPlacementDataSource: [],
      hasPlacementData: false,
      placementTitle: null,
    };
  },
  methods: {
    getDateFormat(date) {
      return moment(date).format("YYYY/MM/DD");
    },
    getDateShortFormat(str) {
      // 書式が"YYYY/MM/DD"の文字列日付を"MM/DD"に変換する
      return moment(moment(str, "YYYY/MM/DD")).format("MM/DD");
    },
    onClickRow(e) {
      this.$router.push({
        name: 'biz-contact-detail',
        params: {
          bizcontactid: e.data.bizContactId
        }
      })
    },
    onClickRefreshData() {
      this.initHomeForm();
    },
    onClickToSubmitWorkerTimeSheet() {
      this.$router.push({
        name: 'worker-time-sheet',
        params: {
          workingDay: moment(this.canSubmitWorkerTimeSheetDate).format("YYYY-MM-DD")
        }
      })
    },
    onClickToConfirmPlacement() {
      this.$router.push({
        name: 'default-placement-list'
      })
    },
    onClickShiftAdjustment() {
      this.$router.push({
        name: 'shift-adjustment'
      })
    },
    initHomeForm() {

      // スマホアクセスログを更新
      workerService.updateAppAccessLog();

      // 汎用マスタから定数データの取得およびホーム画面のコンテンツデータの取得を行う
      this.getConstant()
    },
    getConstant() {
      let self = this
      let worker = self.$store.state.worker

      let promiseGetShiftChangeAutoMsg = masterService.getShiftChangeAutoMsg()
      let promiseGetWorkSheetLimitDays = masterService.getWorkSheetLimitDays(worker.fcId)
      let promiseGetShiftChangeLimitDays = masterService.getShiftChangeLimitDays(worker.fcId)
      let promiseGetDesiredShiftMsg = masterService.getDesiredShiftMsg(worker.fcId)
      let promiseGetAppUpdateUserId = masterService.getAppUpdateUserId()
      let promiseGetWorksheetTimeUnit = masterService.getWorksheetTimeUnit(worker.locationId)

      Promise.all(
        [promiseGetShiftChangeAutoMsg
          , promiseGetWorkSheetLimitDays
          , promiseGetShiftChangeLimitDays
          , promiseGetDesiredShiftMsg
          , promiseGetAppUpdateUserId
          , promiseGetWorksheetTimeUnit])
        .then((results) => {

          if (results[0].messageType == 1
            && results[1].messageType == 1
            && results[2].messageType == 1
            && results[3].messageType == 1
            && results[4].messageType == 1) {

            // storeに保存する
            self.$store.commit(
              {
                type: 'setConstantShiftChangeAutoMsg',
                shiftChangeAutoMsg: results[0].content.shiftChangeAutoMsg,
              })
            self.$store.commit(
              {
                type: 'setConstantWorkSheetLimitDays',
                closingTime: results[1].content.closingTime,
                maxOverTime: results[1].content.maxOverTime,
              })  
            self.$store.commit(
              {
                type: 'setConstantShiftChangeLimitDays',
                shiftChangeLimitDays: results[2].content.shiftChangeLimitDay,
              })
            self.$store.commit(
              {
                type: 'setConstantDesiredShiftMsg',
                desiredShiftMsg: results[3].content.desiredShiftMsg,
                desiredShiftCode: results[3].content.desiredShiftCode,
              })
            self.$store.commit(
              {
                type: 'setConstantAppUpdateUserId',
                appUpdateUserId: results[4].content.appUpdateUserId,
              })
            self.$store.commit(
              {
                type: 'setWorksheetTimeUnit',
                worksheetTimeUnit: results[5].content,
              })

            // コンテンツを作成する
            this.initHomeContents()

          } else {

            // エラーメッセージを表示する
            if (results[0].messageType == 0){
              self.showMessage(results[0].message, 'error');
            } else if (results[1].messageType == 0){
              self.showMessage(results[1].message, 'error');
            } else if (results[2].messageType == 0){
              self.showMessage(results[2].message, 'error');
            } else if (results[3].messageType == 0){
              self.showMessage(results[3].message, 'error');
            } else if (results[4].messageType == 0){
              self.showMessage(results[4].message, 'error');
            } 
         }

        }).catch((errors) => {
          console.log(errors)
        })
    },
    initHomeContents() {

      let self = this;

      // ワークシートが提出できるかどうか
      shiftResultService.getShouldSubmitWorkSheetFirstDate()
        .then((success) => {
          self.canSubmitWorkerTimeSheetDate = null
          self.currentMD = moment().format('(M月D日)')
          if (success.messageType == 1) {
            self.canSubmitWorkerTimeSheetDate = success.content
            self.currentMD = moment(success.content).format('(M月D日)')
          }
        }).catch((errors) => {
          console.log(errors)
        })

      // 募集中シフト検索
      shiftPlanService.getNotOverDesiredShifts()
        .then(success => {
          if (success.messageType == 1) {
            self.shiftDataSource = success.content
            self.hasDesiredShiftData = self.shiftDataSource.length <= 0 ? false : true
          }
        }).catch((errors) => {
          console.log(errors)
        })

      // 未読業務連絡検索
      contactService.getPublicBizContacts(1)
        .then(success => {
          if (success.messageType == 1) {
            self.bizContactsDataSource = success.content
            self.hasBizcontactData = self.bizContactsDataSource.length <= 0 ? false : true
          }
        }).catch((errors) => {
          console.log(errors)
        })

      // 初期配置判定
      workerService.checkPlacement(this.$store.state.worker.fcId)
        .then(success => {         
            switch(success.content)
            {
              case 2:
                self.placementTitle = "初期配置確認";
                self.hasPlacementData = true;
                break;
              case 3:
                self.placementTitle = "ボード情報確認";
                self.hasPlacementData = true;
                break;
              case 4:
                self.placementTitle = "初期配置/ボード情報確認";
                self.hasPlacementData = true;
                break;
              default:
                self.hasPlacementData = false;
                break;
            }          
        }).catch((errors) => {
          console.log(errors)
        })
    },
    showMessage(text, type) {
      notify({
        message: text,
        shading: true
      }, type, process.env.VUE_APP_BASE_MESSAGE_NOTIFY_SHOWTIME)
    }
  },
  mounted() {
    this.initHomeForm()
  },
  watch: {
    '$route': 'initHomeForm'
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxLoadPanel,
    DxAccordion,
    DxTagBox,
    DxCheckBox,
    DxBox,
    DxItem,
    DxButton,
    DxSpeedDialAction,
    DxSelectBox,
    ShiftInfo,
    moment,
  }
};